import { queryOptions, useMutation } from '@tanstack/react-query';
import { axiosDelete, axiosGet, axiosPost, axiosPut } from '../utils/api';

export const getBillingDetail = ({ accessToken, params }) =>
  queryOptions({
    queryKey: ['/billing-detail', params],
    queryFn: async () => {
      const res = await axiosGet('/billing-detail', { params }, accessToken);
      return res.data;
    },
  });

export const useCreateBillingDetail = () =>
  useMutation({
    mutationFn: async ({ data }) => {
      const response = await axiosPost('/billing-detail', data);
      const { token, ...billingDetail } = response;
      if (token) {
        localStorage.setItem('authToken', token);
      }
      return billingDetail;
    },
  });

export const useUpdateBillingDetail = () =>
  useMutation({
    mutationFn: async ({ data }) => {
      const { data: response } = await axiosPut('/billing-detail', data);
      const { token, ...billingDetail } = response;
      if (token) {
        localStorage.setItem('authToken', token);
      }
      return billingDetail;
    },
  });

export const useDeleteBillingDetail = () =>
  useMutation({
    mutationFn: ({ data }) => {
      return axiosDelete('/billing-detail', data);
    },
  });
